import { ProductType } from '@common/enums';
import { convertProductsToProductDetailsList } from '@common/utils';

export const convertWaterfallLaborToProductDetails = convertProductsToProductDetailsList(ProductType.LABOR);
